<section>
	<div class="content">
		<button class="close-button" (click)="boardService.toggleAddOverlay(); $event.stopPropagation()"></button>
		<div class="left-addtask">
			<div class="left-content-wrapper">
				<form class="kanban-form" #addTaskForm="ngForm">
					<h1>Add Task</h1>
					<div class="form-title div-cont">
						<label class="form-label">
							Title<span class="required-asterisk">*</span>
						</label>
						<input class="input" [(ngModel)]="taskList.title" name="title" placeholder="Enter a title" type="text"
							required #title="ngModel" [class.errorborder]="!title.valid && title.touched" />
					</div>
					<div class="invalid-input">
						@if (!title.valid && title.touched) {
						<div>This Field is required</div>
						}
					</div>
					<div class="form-description div-cont">
						<label class="form-label">
							Description
						</label>
						<textarea [(ngModel)]="taskList.description" placeholder="Enter a Description " name="description"
							id=""></textarea>
					</div>
					<div class="form-date div-cont">
						<label class="form-label">
							Due date<span class="required-asterisk">*</span>
						</label>
						<input #picker (click)="picker.showPicker()" [(ngModel)]="taskList.dueDate" class="input-date" type="date" onkeydown="return false;" [min]="currentDate" name="dueDate" required
							#dueDate="ngModel" [class.errorborder]="!dueDate.valid && dueDate.touched" />
					</div>
					<div class="invalid-input">
						@if (!dueDate.valid && dueDate.touched) {
						<div>This Field is required</div>
						}
					</div>
				</form>
			</div>
			<label class="form-label required-label">
				<span class="required-asterisk">*</span>This field is required
			</label>
		</div>

		<div class="line">
			<div class="hyphen"></div>
		</div>



		<div class="right-addtask">
			<div class="right-content-wrapper">
				<div class="kanban-addtask-priority">
					<p>Priority</p>
					<div class="priority-buttons">
						<button (click)="changeToUrgent()" [class.active-urgent]="taskList.priority === 'Urgent'">
							<span>Urgent</span>
							@if(taskList.priority !== 'Urgent'){
							<img src="assets/img/kanban-edit-overlay/urgent-arrow.svg" alt="" />
							} @else {
							<img src="assets/img/kanban-edit-overlay/white-urgent.svg" alt="" />
							}
						</button>

						<button (click)="changeToMedium()" [class.active-medium]="taskList.priority === 'Medium'">
							<span>Medium</span>
							@if(taskList.priority !== 'Medium'){
							<img src="assets/img/kanban-edit-overlay/medium-arrow.svg" alt="" />
							} @else {
							<img src="assets/img/kanban-edit-overlay/white-medium.svg" alt="" />
							}
						</button>

						<button (click)="changeToLow()" [class.active-low]="taskList.priority === 'Low'">
							<span>Low</span>
							@if(taskList.priority !== 'Low'){
							<img src="assets/img/kanban-edit-overlay/low-arrow.svg" alt="" />
							} @else {
							<img src="assets/img/kanban-edit-overlay/white-low.svg" alt="" />
							}
						</button>
					</div>
				</div>
				<!-- Assigned-to-Dropdown -->
				<div class="kanban-assigned-to">
					<span class="assigned-span">Assigned to</span>
					<div class="all-user-container">
						<mat-select [(ngModel)]="taskList.assignedTo" panelClass="select-to-assign" required name="name" id=""
							multiple>
							@for (user of overlayState.contactList; track $index) {
							<mat-option id={{$index}} [value]="user">
								<div class="option-text">
									<div class="select-initials" [style.background]="user.color">{{user.initials}}</div>
									<div>{{user.firstName}} {{user.lastName}}</div>
								</div>
							</mat-option>
							}
						</mat-select>

					</div>
					<div class="already-assigned">
						@for (assigned of taskList.assignedTo?.slice(0, 3) || [];; track $index) {
						<div id={{$index}} class="select-initials" [style.background]="assigned.color">
							{{assigned.initials}}
						</div>
						}
						@if ((taskList.assignedTo?.length || 0) > 3) {
						<div class="more-users">+{{ (taskList.assignedTo?.length || 0) - 3 }}</div>
						}
					</div>
				</div>
				<!-- Category-Dropdown -->

				<div class="category-dropdown">
					<label class="form-label">Category<span class="required-asterisk">*</span></label>
					<select [(ngModel)]="taskList.category" panelClass="select-category" name="category" required
						#category="ngModel" [class.errorborder]="!category.valid && category.touched">
						<option value="Management">Management</option>
						<option value="Technical">Technical</option>
						<option value="Developement">Developement</option>
						<option value="Design">Design</option>
						<option value="Documentation">Documentation</option>
						<option value="User Story">User Story</option>
					</select>
				</div>
				<div class="invalid-input">
					@if (!category.valid && category.touched) {
					<div>This Field is required</div>
					}
				</div>
				<!-- Subtask Section -->
				<div class="list-of-members">
					<div class="kanban-overlay-subtask">
						<span class="subtask-span">Subtask</span>
						<div class="subtaskfield" (click)="$event.stopPropagation();">
							<input (keydown)="onKeydown($event)" [(ngModel)]="subtaskString" type="text" (focus)="isInputFocused = true" (blur)="handleBlur()">
							@if(!isInputFocused){
							<div class="add" (click)="setFocusOnInput()">
								<img src="assets/img/kanban-edit-overlay/plus-zichen.svg" alt="" />
							</div>
							}@else {
							<div class="submit-cancel">
								<button (click)="emptySubtask()">
									<img src="assets/img/kanban-edit-overlay/exit-subtask.svg" alt="">
								</button>
								<div class="grey-line"></div>
								<button (click)="pushToSubtask()">
									<img src="assets/img/kanban-edit-overlay/checkmark-subtask.svg" alt="">
								</button>
							</div>
							}
						</div>
						<div class="each-sub-task">
							@for (pushedSubtask of taskList.subTaskFillTest; track $index) {
							@if (editingSubtaskIndex === $index) {
							<li (click)="$event.stopPropagation()">
								<textarea [(ngModel)]="pushedSubtask.text"></textarea>
								<button (click)="spliceSubtask($index)">
                                    <img src="assets/img/kanban-add/subTaskDeleteButton.png" alt="delete">
								</button>
								<button (click)="saveEditingSubtask($index); $event.stopPropagation()">
									<img src="assets/img/kanban-add/checkmark-subtask.svg" alt="save">
                                </button>
							</li>
							}@else {
							<li (dblclick)="startEditingSubtask($index)">
								{{ pushedSubtask.text }}
							</li>
							}
							}
						</div>
						<div class="each-sub-task-container">
							<button class="clear" (click)="resetForm()">
								Clear
								<svg width="32" height="32" viewBox="0 0 32 32" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
									<path
										d="M16 17.4L11.1 22.3C10.9167 22.4834 10.6834 22.575 10.4 22.575C10.1167 22.575 9.88338 22.4834 9.70005 22.3C9.51672 22.1167 9.42505 21.8834 9.42505 21.6C9.42505 21.3167 9.51672 21.0834 9.70005 20.9L14.6 16L9.70005 11.1C9.51672 10.9167 9.42505 10.6834 9.42505 10.4C9.42505 10.1167 9.51672 9.88338 9.70005 9.70005C9.88338 9.51672 10.1167 9.42505 10.4 9.42505C10.6834 9.42505 10.9167 9.51672 11.1 9.70005L16 14.6L20.9 9.70005C21.0834 9.51672 21.3167 9.42505 21.6 9.42505C21.8834 9.42505 22.1167 9.51672 22.3 9.70005C22.4834 9.88338 22.575 10.1167 22.575 10.4C22.575 10.6834 22.4834 10.9167 22.3 11.1L17.4 16L22.3 20.9C22.4834 21.0834 22.575 21.3167 22.575 21.6C22.575 21.8834 22.4834 22.1167 22.3 22.3C22.1167 22.4834 21.8834 22.575 21.6 22.575C21.3167 22.575 21.0834 22.4834 20.9 22.3L16 17.4Z"
										fill="currentColor" />
								</svg>
							</button>
							<button class="create-task" (click)="onSubmit()">
								Create Task
								<img src="assets/img/add-contacts/check.svg" alt="Create Task" />
							</button>
						</div>
					</div>
				</div>

			</div>
		</div>
		<div class="user-feedback">
			<img src="assets/img/kanban-add/Frame_73.png" alt="">
		</div>
	</div>
</section>